import React from 'react'

import { Spinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, arrayOf, shape } from 'prop-types'


import LegacyDataTable from 'Pods/Shared/DataTable/LegacyDataTable'

import { renderDate } from '../../../formatter'
import EmptyMessage from '../../EmptyMessage'

const renderDonationRate = (value) => {
  return typeof value === 'number' ? `${value}%` : '-'
}

function DonationHistory({ donations, isLoading, columnsConfig }) {
  if (isLoading) {
    return (
      <div className="spinner-container">
        <Spinner />
      </div>
    )
  }

  return (
    <div className="cgt-mt-20">
      <h3 className="cgt-legacy-text-lead cgt-mb-10">Donations history</h3>
      <LegacyDataTable
        columnsConfig={columnsConfig}
        data={donations}
        EmptyMessage={<EmptyMessage title="No donations yet" />}
        renderCustomCell={{
          date: renderDate,
          donationRate: renderDonationRate,
        }}
      />
    </div>
  )
}

DonationHistory.propTypes = {
  donations: arrayOf(shape({})).isRequired,
  isLoading: bool.isRequired,
  columnsConfig: shape({}).isRequired,
}

export default DonationHistory
